module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-rural-574c9876baab3f7cddbdc0400f528ec5.svg";